import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as homeReducer from "containers/Home/reducer";

import Introspect from "components/Next/Strategy/Introspect";

class IntrospectContainer extends React.PureComponent {
  render() {
    return <Introspect {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    introspectCountsFromData: (runId, column, successValue) =>
      dispatch(setupReducer.introspectCountsFromData(runId, column, successValue))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;

  const innerId = projectReducer.getInnerId(state, id);
  const runId = innerId ? innerId : id;

  const datasetId = setupReducer.getDatasetId(state, runId);

  return {
    id: id,
    runId: runId,
    setup: setupReducer.getSetup(state, runId),
    fields: homeReducer.getFields(state, datasetId),
    dataset: homeReducer.getDataset(state, datasetId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(IntrospectContainer);
